import { useState } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const AboutSmartTv = (): JSX.Element => {
    const [isOpen, changePopupState] = useState(false);

    const handleClosePopup = () => {
        changePopupState(false);
    };

    const handleOpenPopup = () => {
        changePopupState(true);
    };

    return (
        <>
            <ControlElement type={'large'} onClick={handleOpenPopup}>Smart TV</ControlElement>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <TextWrapper>
                        <H3 style={{ marginRight: 45 }}>Про Smart TV</H3>
                        <Paragraph4 $color={COLORS.TextInfo}>
                            <b>Телевизор со&nbsp;Smart TV</b>&nbsp;&mdash; это как большой планшет. На&nbsp;него можно устанавливать приложения, выходить
                            в&nbsp;интернет, смотреть видео и&nbsp;т.&nbsp;д.
                        </Paragraph4>
                        <Paragraph4 $color={COLORS.TextInfo}>
                            Если телевизор со&nbsp;Smart&nbsp;TV, то&nbsp;на&nbsp;пульте дистанционного управления должна быть кнопка вызова этой
                            функции. На&nbsp;этой кнопке обычно нанесена <b>иконка в&nbsp;виде домика,</b> или
                            надпись &laquo;Smart&raquo; или &laquo;Smart&nbsp;TV&raquo;.
                        </Paragraph4>
                    </TextWrapper>

                    <ButtonGroup>
                        <Button bType={'action'} size={'large'} onClick={handleClosePopup}>Закрыть</Button>
                    </ButtonGroup>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};

export default AboutSmartTv;
